import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installDemoErrorCapture } from './utils/demoIssues';

// D255: reports JS errors / unhandled rejections during a demo session only (no-op otherwise).
installDemoErrorCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers the app-shell service worker in production only. See
// serviceWorkerRegistration.js and public/service-worker.js for what it does
// and — importantly — what it deliberately does NOT cache (all API calls).
serviceWorkerRegistration.register();